import { Button, ButtonGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';
import { getCPDUnassignedBreachedCases, getFIUnassignedBreachedCases, getPublicUnassignedBreachedCases, getUnassignedBreachedCases } from '../../../redux/api/cases';
import { getPrivilegeStatus } from '../../../util';
import { Form, Formik } from 'formik';
import SelectInput from '../../../components/common/SelectInput';
import { getAllSubcategories } from '../../../redux/api/userMgt';

const EscalatedCases = ({ user }) => {
    const [processing, setProcessing] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    // const [records, setRecords] = useState([]);
    const [publicRecords, setPublicRecords] = useState([]);
    const [cpdRecords, setCpdRecords] = useState([]);
    const [fiRecords, setFiRecords] = useState([]);

    const [relationshipOfficers, setRelationshipOfficers] = useState([]);
    const [teams, setTeams] = useState([]);
    const [section, setSection] = useState(0);
    const [selectedGroup, setSelectedGroup] = useState();
    const [paginationData, setPaginationData] = useState({
        fiRecords: {
            start: 0,
            length: 0,
            total: 0,
            totalFiltered: 0,
            searchParams: {},
        },
        cpdRecords: {
            start: 0,
            length: 0,
            total: 0,
            totalFiltered: 0,
            searchParams: {},
        },
        publicRecords: {
            start: 0,
            length: 0,
            total: 0,
            totalFiltered: 0,
            searchParams: {},
        },
    });
    const [subCategories, setSubCategories] = useState([]);

    const sections = [
        {
            name: 'Public Portal Escalated Cases',
            id: 'getPublicUnassignedBreachedCases',
        },
        { name: 'CPD Escalated Cases', id: 'getCPDUnassignedBreachedCases' },
        { name: 'FI Escalated Cases', id: 'getFIUnassignedBreachedCases' },
    ];

    const fetchOthers = () => {
        getUnassignedBreachedCases({ start: 0, length: 1 }, false, selectedGroup)
            .then((res) => {
                setRelationshipOfficers(res?.resultObject?.relationshipOfficers || []);
            })
            .catch(() => console.log('Error fetching relationship officers'));

        getAllSubcategories()
            .then((resp) => {
                setSubCategories(resp?.resultObject || []);
            })
            .catch(() => console.log('Error fetching sub categories'));
    };

    const init = async (start = 0, length = user.paginationSize) => {
        try {
            setProcessing(true);
            const pub = await getPublicUnassignedBreachedCases({ start, length }, false, selectedGroup);
            const fiCases = await getFIUnassignedBreachedCases({ start, length }, false, selectedGroup);
            const cpdCases = await getCPDUnassignedBreachedCases({ start, length }, false, selectedGroup);

            setPublicRecords(pub?.resultObject?.dataTableResponse?.data || []);
            setCpdRecords(cpdCases?.resultObject?.dataTableResponse?.data || []);
            setFiRecords(fiCases?.resultObject?.dataTableResponse?.data || []);

            setPaginationData({
                fiRecords: { start, length, total: fiCases?.resultObject?.dataTableResponse?.recordsTotal, totalFiltered: fiCases?.resultObject?.dataTableResponse?.recordsFiltered },
                cpdRecords: { start, length, total: cpdCases?.resultObject?.dataTableResponse?.recordsTotal, totalFiltered: cpdCases?.resultObject?.dataTableResponse?.recordsFiltered },
                publicRecords: { start, length, total: pub?.resultObject?.dataTableResponse?.recordsTotal, totalFiltered: pub?.resultObject?.dataTableResponse?.recordsFiltered },
            });

            fetchOthers();
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const getRecords = (section) => {
        switch (section) {
            case 0:
                return publicRecords;
            case 1:
                return cpdRecords;
            case 2:
                return fiRecords;
            default:
                return [];
        }
    };

    const getExportFunction = async (section) => {
        try {
            let resp;
            switch (section) {
                case 0:
                    resp = await getPublicUnassignedBreachedCases({ searches: paginationData?.publicRecords?.searchParams ?? {} }, true);
                    enqueueSnackbar(resp?.message || 'Your report is being processed, kindly check the reports page for progress');
                    break;
                case 1:
                    resp = await getCPDUnassignedBreachedCases({ searches: paginationData?.cpdRecords?.searchParams ?? {} }, true);
                    enqueueSnackbar(resp?.message || 'Your report is being processed, kindly check the reports page for progress');
                    break;
                case 2:
                    resp = await getFIUnassignedBreachedCases({ searches: paginationData?.fiRecords?.searchParams ?? {} }, true);
                    enqueueSnackbar(resp?.message || 'Your report is being processed, kindly check the reports page for progress');
                    break;
                default:
                    break;
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const getPageData = async () => {
        switch (section) {
            case 0:
                return paginationData.publicRecords;
            case 1:
                return paginationData.cpdRecords;
            case 2:
                return paginationData.fiRecords;
            default:
                return {};
        }
    };

    const search = async (searches) => {
        try {
            const start = 0;
            const length = user.paginationSize;
            const searchParams = searches;
            let resp;
            switch (section) {
                case 0:
                    resp = await getPublicUnassignedBreachedCases({ searches }, true);
                    setPublicRecords(resp?.resultObject?.dataTableResponse?.data || []);
                    setPaginationData({
                        ...paginationData,
                        publicRecords: {
                            start,
                            length,
                            searchParams,
                            total: resp?.resultObject?.dataTableResponse?.recordsTotal,
                            totalFiltered: resp?.resultObject?.dataTableResponse?.recordsFiltered,
                        },
                    });
                    break;
                case 1:
                    resp = await getCPDUnassignedBreachedCases({ searches }, true);
                    setCpdRecords(resp?.resultObject?.dataTableResponse?.data || []);
                    setPaginationData({
                        ...paginationData,
                        cpdRecords: { start, length, searchParams, total: resp?.resultObject?.dataTableResponse?.recordsTotal, totalFiltered: resp?.resultObject?.dataTableResponse?.recordsFiltered },
                    });
                    break;
                case 2:
                    resp = await getFIUnassignedBreachedCases({ searches }, true);
                    setFiRecords(resp?.resultObject?.dataTableResponse?.data || []);
                    setPaginationData({
                        ...paginationData,
                        fiRecords: { start, length, searchParams, total: resp?.resultObject?.dataTableResponse?.recordsTotal, totalFiltered: resp?.resultObject?.dataTableResponse?.recordsFiltered },
                    });
                    break;
                default:
                    break;
            }
            if (resp?.statusCode == '000') {
                if (resp?.resultObject?.dataTableResponse?.data?.length == 0) {
                    enqueueSnackbar('No result found for search parameters', {
                        variant: 'info',
                    });
                }
            } else {
                enqueueSnackbar(resp?.message || 'An error occurred', {
                    variant: 'info',
                });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const setData = async (user) => {
        const arr = await new Promise((resolve) => {
            let count = -1;
            let list = [];
            user?.userData?.teams?.forEach(({ groupId, ...props }, key) => {
                const inList = Boolean(list?.find((ls) => ls.groupId == groupId));
                if (!inList) {
                    list.push({ ...props, groupId });
                }
                count += 1;
                if (key == count) resolve(list);
            });
        });

        setTeams(arr || []);
        setSelectedGroup(user?.userData?.teams?.[0]?.groupId || '');
    };

    useEffect(() => {
        if (selectedGroup) init();
    }, [selectedGroup, user.paginationSize]);

    useEffect(() => {
        setData(user);
    }, [user]);

    return (
        <PageContainer pageTitle={sections?.[section]?.name || ''} processing={processing}>
            {Boolean(teams?.length > 1) && (
                <Formik initialValues={{ team: selectedGroup }} enableReinitialize>
                    {() => (
                        <Form className="p-2 mb-1 m-4 mt-0">
                            <SelectInput
                                options={teams}
                                field="groupId"
                                fieldDisplay="name"
                                label="Active Team"
                                id="team"
                                customChange={(name, value) => {
                                    setSelectedGroup(value);
                                }}
                            />
                        </Form>
                    )}
                </Formik>
            )}

            <ButtonGroup variant="outlined" className="pl-2 pr-2 mb-2" fullWidth>
                {sections.map(
                    (sec, key) =>
                        getPrivilegeStatus(sec.id) && (
                            <Button variant={section === key ? 'contained' : 'outlined'} key={key} onClick={() => setSection(key)}>
                                {sec.name}
                            </Button>
                        )
                )}
            </ButtonGroup>

            {/* <Filters 
                searchFields={[
                    { id: 'user_id', label: 'Case ID' },
                    { id: 'user_id', label: 'Tracking Reference Number' },
                    { id: 'account_status', label: 'Name of Complainant' },
                    { id: 'name', label: 'Unique Identification No.' },
                    // { id: 'case_type', label: 'Case Type', type: 'select', options: [{ code: 'public' }], field: 'code', fieldDisplay: 'code' },

                ]}
                // searchFunction={searchFunction}
            /> */}

            <CaseTable
                cases={getRecords(section)}
                showPendingActionsBtn={false}
                showAssignBtn
                showAssignFooterBtn
                showCloseCaseBtn={false}
                showDeEscalateCaseBtn={false}
                showEscalateCaseBtn={false}
                showResolveCaseBtn={false}
                relationshipOfficers={relationshipOfficers}
                exportFunction={async () => await getExportFunction(section)}
                searchFunction={search}
                initFunction={init}
                subCategories={subCategories}
                showRecategorizeCaseBtn
                paginationData={getPageData}
            />
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(EscalatedCases);
